import { Stack, Typography, styled } from '@mui/material';
import { ButtonsPrimary } from '../ComponentApp/buttoms/ButtonsXcala';

const SectionNoProduct = styled(Stack)({
  backgroundColor: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 0px 6.828890800476074px rgba(0, 0, 0, 0.12)',
  borderRadius: '4px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '2px 11.706669807434082px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  flex: '1',
  margin: '0px',
  height: '100%',
  width: '100%',
  minHeight: '218px',
});

const ContentNoProduct = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px',
  height: '120px',
  width: '100%',
});
const IconsNoProduct = styled('img')({
  height: '120px',
  width: '40%',
  objectFit: 'cover',
  margin: '0px',
});
const BodyTextNoProduct = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px 0px 0px 6px',
  width: '100%',
  overflow: 'hidden',
  gap: '10px',
  [`@media (min-width:1200px) and (max-width:1400px)`]: {
    gap: '2px',
  },
}));

const TitleNoProduct = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.h4.fontWeight,
  fontSize: 'clamp(1.1rem, 1.5vw + 0.5rem, 1.3rem)',
  letterSpacing: '-0.4px',
  textDecoration: 'none',
  lineHeight: '20px',
  textTransform: 'none',
  margin: '0px',
}));

const ParagraphNoProduct = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.textLight.main,
  fontWeight: theme.typography.titleText.fontWeight,
  fontSize: '14px',
  letterSpacing: '-0.39022237062454224px',
  textDecoration: 'none',
  lineHeight: '12.962230682373047px',
  textTransform: 'none',
  margin: '0px 0px 0px 0px',
}));

const SectionNoMarketValue = ({ handleRedirect, tap }) => {
  return (
    <SectionNoProduct>
      <ContentNoProduct>
        <IconsNoProduct src='/assets/images/dashboard/noProducts.gif' alt={'Cargando Product'} />
        <BodyTextNoProduct>
          <Stack>
            <TitleNoProduct>Invierte como los que saben</TitleNoProduct>
          </Stack>
          <Stack sx={{ mt: '8px', mb: '12px' }}>
            <ParagraphNoProduct>
              En Xcala, los activos alternativos son para todos
            </ParagraphNoProduct>
          </Stack>
          <ButtonsPrimary
            sx={{
              whiteSpace: 'normal',
              fontSize: {
                xs: '16px',
                md: 'clamp(12px, 0.3vw + 0.5rem, 14px)',
              },
            }}
            name={`Visita nuestros ${tap === 'fondos' ? 'Fondos' : 'Portfolios'}`}
            onClick={() => handleRedirect()}
            fullWidth
          />
        </BodyTextNoProduct>
      </ContentNoProduct>
    </SectionNoProduct>
  );
};

export default SectionNoMarketValue;
